import React, { useState } from 'react';
import { Resource } from '../../../../common/constants/resource';
import { MIBSection } from '../../../tasks/types/mib';
import styles from './MIBDetail.module.scss';
import { RenderMIBSection } from './MIBSection';

type ResponseTab = 'hit' | 'try';

const isHitResult = (result: string) =>
  result?.toLocaleLowerCase() ===
  Resource.MIB_RESULT_HIT_VALUE.toLocaleLowerCase();

export const MIBResponses = ({ sections }: { sections: MIBSection[] }) => {
  const hitSections = sections.filter(s => isHitResult(s.detail.result));
  const trySections = sections.filter(s => !isHitResult(s.detail.result));

  const initialTab: ResponseTab = hitSections.length > 0 ? 'hit' : 'try';
  const [activeTab, setActiveTab] = useState<ResponseTab>(initialTab);

  const activeSections = activeTab === 'hit' ? hitSections : trySections;

  return (
    <div>
      <div className={styles.Tabs}>
        <button
          type="button"
          className={`${styles.Tab} ${
            activeTab === 'hit' ? styles.TabActive : ''
          }`}
          onClick={() => setActiveTab('hit')}
        >
          {Resource.MIB_TAB_HITS}
          <span className={`${styles.TabCount} ${styles.TabCountHit}`}>
            {hitSections.length}
          </span>
        </button>
        <button
          type="button"
          className={`${styles.Tab} ${
            activeTab === 'try' ? styles.TabActive : ''
          }`}
          onClick={() => setActiveTab('try')}
        >
          {Resource.MIB_TAB_TRYS}
          <span className={`${styles.TabCount} ${styles.TabCountTry}`}>
            {trySections.length}
          </span>
        </button>
      </div>
      {activeSections.length === 0 ? (
        <div className={styles.EmptyState}>—</div>
      ) : (
        activeSections.map((section, idx) =>
          RenderMIBSection(section, idx + 1, activeTab),
        )
      )}
    </div>
  );
};
